
<div>
  <BotBlob v-if="expand" :expand="expand" @expand="expand = !expand"/>
  <div v-else class="chat-container"
       :style="{'max-width': chatWidth + 'px', 'max-height': chatHeight + 'px'}">
    <BotHeader ref="chatHeader" @expand="expand = !expand"/>
    <BotMessageWindow :chatHeight="chatWindowHeight"/>
  </div>
</div>
